<div class="dialog-header" cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>
    <h2 mat-dialog-title>Reminders Helper</h2>
    <mat-icon>drag_indicator</mat-icon>
</div>
<mat-dialog-content class="dialog-content">
    <div class="controls">
        <div class="population-chooser">
            <mat-tab-group [selectedIndex]="population === 'filter' ? 0 : 1"
                (selectedIndexChange)="onTabChange($event)">
                <mat-tab label="From filter results"></mat-tab>
                <mat-tab label="All direct reports"></mat-tab>
            </mat-tab-group>
        </div>
    </div>

    <div class="user-list-holder">
        <div class="list-header">
            <mat-checkbox [checked]="allDisplayedSelected" (change)="selectAll($event.checked)">
                Select all ({{ displayedUsers.length }})
            </mat-checkbox>
            <div class="selected-count">{{ selectedUserIds.size }} selected
                <button mat-icon-button (click)="copyToClipboard()"><mat-icon>content_copy</mat-icon></button>
            </div>
        </div>

        <div class="user-list">
            <mat-selection-list>
                <mat-list-option *ngFor="let u of displayedUsers" [selected]="isSelected(u)" (click)="toggleUser(u)">
                    <div class="user-line">
                        <span class="name">{{ u.displayName }}</span>
                        <span class="email">{{ u.email }}</span>
                    </div>
                </mat-list-option>
            </mat-selection-list>
        </div>
    </div>

    <div class="actions-grid">
    <mat-form-field appearance="fill">
      <mat-label for="reminder-option">Select a Reminder</mat-label>
      <mat-select [(ngModel)]="whichTemplate">
        <mat-option value="unsubmitted">"Please submit" template</mat-option>
        <mat-option value="review">"Please review" template</mat-option>
        <mat-option value="other">Blank template</mat-option>
      </mat-select>
    </mat-form-field>
        <button mat-flat-button color="primary" (click)="openAsSystemMail()">Open as email</button>
    </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-stroked-button (click)="cancel()">Close</button>
</mat-dialog-actions>